import React, { ChangeEvent, useEffect, useMemo, useState } from 'react';

import { Color, IconName } from '../../enums';
import { UseState } from '../../types';
import { Markdown } from '../markdown/markdown.component';

import {
  CheckMark,
  Container,
  StyledIcon,
  CheckboxInput,
  Label,
  StyledValidationBar,
  Wrapper,
} from './checkbox.styled';
import { CheckboxProps } from './checkbox.types';

export const Checkbox: React.FC<CheckboxProps> = (props: CheckboxProps): JSX.Element => {
  const {
    disabled = false,
    id,
    invalid = false,
    checked = false,
    required,
    label,
    onChange,
    color,
    className,
    validationMessage 
  }: CheckboxProps = props;
  const [isChecked, setIsChecked]: UseState<boolean> = useState<boolean>(checked);
  const idValue: string = useMemo((): string => id || `${label ?? Math.floor(Math.random() * 10)}-${Math.floor(Math.random() * 10)}`, []);

  useEffect(
    (): void => {
      if (checked !== isChecked) {
        setIsChecked(checked);
      }
    },
    [checked]
  );

  const onChangeAction: (e: ChangeEvent<HTMLInputElement>) => void = (e: ChangeEvent<HTMLInputElement>): void => {
    if (disabled) {
      return;
    }
    setIsChecked(e.target.checked);
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  return (
    <Wrapper className={className}>
      <Container>
        <CheckboxInput
          type='checkbox'
          disabled={disabled}
          required={required}
          checked={isChecked}
          id={idValue}
          onChange={onChangeAction}
          $color={color}
        />
        <CheckMark $invalid={invalid} $checked={isChecked}>
          <StyledIcon
            name={IconName.Check}
            size={12}
            color={Color.White}
          />
        </CheckMark>
        {!!label && (
          <Label htmlFor={idValue} $disabled={disabled}>
            <Markdown text={label} />
          </Label>
        )}
      </Container>
      <StyledValidationBar message={validationMessage} />
    </Wrapper>
  );
};
